import { useContext } from 'react';
import CountryContext from '../contexts/CountryContext';

/**
 * Convenience hook for accessing country configuration.
 * Falls back to IN defaults if CountryContext is not available.
 */
export function useCountryConfig() {
  return useContext(CountryContext);
}
